import axios from 'axios';
import { BASE_URL, BULK_EPISODE_JOBS_API_PATH } from 'constants/api';

import {
  BulkEpisodeDryRunResult,
  BulkEpisodeJobDetail,
  BulkEpisodeJobListItem,
  BulkEpisodeJobState,
} from '../types';

class BulkEpisodeService {
  /**
   * CSV 업로드 -> 스테이징 + dry-run 미리보기. 라이브 생성 없음.
   */
  public async createDryRun(file: File, seasonId: number): Promise<BulkEpisodeDryRunResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('season_id', String(seasonId));
    formData.append('dry_run', 'true');

    const response = await axios.post(`${BASE_URL}${BULK_EPISODE_JOBS_API_PATH}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  /**
   * 승인(비동기). PREVIEWED -> APPROVED 로 표시하고 AWS Batch 잡을 제출(202).
   * 실제 생성은 백그라운드에서 진행 — getJob 으로 폴링한다.
   */
  public async approve(jobId: number): Promise<BulkEpisodeJobState> {
    const response = await axios.post(
      `${BASE_URL}${BULK_EPISODE_JOBS_API_PATH}${jobId}/approve/`
    );
    return response.data;
  }

  /** 진행 상황 폴링: job 상태 + stats(created/failed 등) + 행 */
  public async getJob(jobId: number): Promise<BulkEpisodeJobDetail> {
    const response = await axios.get(
      `${BASE_URL}${BULK_EPISODE_JOBS_API_PATH}${jobId}/`
    );
    return response.data;
  }

  /** 최근 작업 목록 (진행중/완료). 새로고침/이탈 후에도 DB 기반으로 추적. */
  public async getJobs(): Promise<{ jobs: BulkEpisodeJobListItem[] }> {
    const response = await axios.get(`${BASE_URL}${BULK_EPISODE_JOBS_API_PATH}`);
    return response.data;
  }
}

export const bulkEpisodeService = new BulkEpisodeService();
